<template>
  <form-item
    :text-error="errorText"
    :text-before="successText"
    :is-valid="isSuccess"
  >
    <coupon
      v-model="cardValue"
      placeholder="Карта Много.ру"
      :is-loading="isLoadingState"
      :button-text="buttonText"
      @keypress.native="filterInput"
      @apply="handlerApplyMnogoRuCard"
      @remove="handlerRemoveAppliedMnogoRuCard"
    >
      <template v-if="showIcon" #icon>
        <mnogoru16
          class="b24-input-control__control-icon"
          :width="16"
          :height="16"
        />
      </template>
    </coupon>
  </form-item>
</template>

<script>
import { defineComponent, onBeforeMount, watch } from '@vue/composition-api';
import { Coupon, FormItem } from '@book24/ui-components';

import useMnogoRuCard from '@/compositions/useMnogoRuCard';

import Mnogoru16 from '@/assets/sprite/svg/16/Mnogoru_16.svg';

export default defineComponent({
  name: 'MnogoRuCardAsCoupon',
  components: {
    Coupon,
    FormItem,
    Mnogoru16,
  },
  props: {
    buttonText: { type: String, default: 'Применить' },
    showIcon: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const mnogoRuCard = useMnogoRuCard();

    const handlerApplyMnogoRuCard = async () => {
      await mnogoRuCard.applyMnogoRuCard()
        .then(() => emit('changeCard'));
    };

    const handlerRemoveAppliedMnogoRuCard = async () => {
      await mnogoRuCard.removeAppliedMnogoRuCard()
        .then(() => emit('changeCard'));
    };

    watch(
      () => mnogoRuCard.isApplied.value,
      (value) => {
        emit('changeShowCoupon', value);
      },
    );

    onBeforeMount(async () => {
      await mnogoRuCard.fetchAppliedMnogoRuCard();
    });

    return {
      ...mnogoRuCard,
      handlerApplyMnogoRuCard,
      handlerRemoveAppliedMnogoRuCard,
    };
  },
});
</script>
